{
    "of": "von",
    "replaces": "ersetzt"
}
